export const BASE_URL = "https://straytostray-backend.onrender.com";